import { getDashboardQueryKey } from "apps/myExperience/context/dashboard/dataloader";
import { getParticipantDetailQueryKey } from "apps/myExperience/context/participantDetails/dataloader";
import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { QueryClient } from "react-query";
import { usePostApiData } from "shared/datalayer";
import ApiHideRegistrationParticipantListingResponse from "shared/types/ApiHideRegistrationParticipantListingResponse";
import { ApiRegistrationParticipantForDashboardDetails } from "shared/types/ApiRegistrationParticipantForDashboardDetails";
import { ApiRegistrationParticipantProgramDetails } from "shared/types/ApiRegistrationParticipantProgramDetails";

export function useHideParticipantFromList({
  registrationParticipantId,
  uiVersion
}: {
  registrationParticipantId?: string;
  uiVersion?: number;
}) {
  return usePostApiData<ApiHideRegistrationParticipantListingResponse, any>(MyExpApi.HIDE_PARTICIPANT_FROM_LIST, {
    clientOptions: { params: { registrationParticipantId, uiVersion } }
  });
}

export function updateDashboardDataAfterHideParticipant({
  queryClient,
  response
}: {
  queryClient: QueryClient;
  response: ApiHideRegistrationParticipantListingResponse;
}) {
  //update participant api query
  queryClient.setQueryData(
    getParticipantDetailQueryKey(response.registrationParticipantId),
    (data?: ApiRegistrationParticipantProgramDetails) => {
      return {
        ...data,
        hideFromAttendeeListing: response.hideFromAttendeeListing,
        uiVersion: response.uiVersion
      } as ApiRegistrationParticipantProgramDetails;
    }
  );
  //update dashboard api query
  queryClient.setQueryData(
    getDashboardQueryKey(response.registrationParticipantId),
    (data?: ApiRegistrationParticipantForDashboardDetails) => {
      return {
        ...data,
        hideFromAttendeeListing: response.hideFromAttendeeListing,
        uiVersion: response.uiVersion
      } as ApiRegistrationParticipantForDashboardDetails;
    }
  );
}
